<template>
	<side-window :tabs="[]" :active="active" class="contact" title="Eksporter" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<form-line-layout>
						<date-select-view label="Fra" v-model="entity.from" :controller="$store.state.popupController" />
					</form-line-layout>
					<form-line-layout>
						<date-select-view label="Til" v-model="entity.to" :controller="$store.state.popupController" />
					</form-line-layout>
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Timer" @click="onAddButtonClick" />
			<button-view label="Tillæg" @click="onExtraButtonClick" />
			<button-view label="Alt" @click="onAllButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import MoveTaskModel from '../model/MoveTask'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import AddressView from '../views/AddressView';

	import merge from '../functions/merge'
 
	const stop = {

	};

	export default {
		data: function () {
			return {
				active: 'details',
				entity: {}
			};
		},
		watch: {
	
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'employees',
						label: 'Medarbejdere'
					},
					{
						name: 'vehicles',
						label: 'Køretøjer'
					}
				];
			},
			_employees() {
				return this.employees.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			},
			_vehicles() {
				return this.vehicles.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			}
		},
		props: {
			submit: {
				type: Function,
				default: function () {}
			},
			ent: {
				type: Object,
				retuired: true
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(this.entity, 'hours');
			},
			onExtraButtonClick() {
				
				this.submit(this.entity, 'extra');
			},
			onAllButtonClick() {
				
				this.submit(this.entity, 'all');
			}
		},
		mounted: function() {
			this.entity = Object.assign({
				from: (new Date()).format('Y-m-d'),
				to: (new Date()).format('Y-m-d')
			}, this.ent);
		}
	}
</script>

<style lang="scss">
	
</style>
